import { render } from "./AppointmentView.vue?vue&type=template&id=d18f7ed4"
import script from "./AppointmentView.vue?vue&type=script&lang=js"
export * from "./AppointmentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__